import React from 'react'
import { Translation } from 'react-i18next'
import { Field, useWatch } from '../../form'
import { withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import SortableTable from '../../utils/sortableTable'
import WorkshiftJournalRowContainer from '../../containers/invoice/workshiftJournalRow.container'

class WorkshiftJournalComponent extends React.Component {
  render() {
    return <WorkshiftJournal {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  switch: {
    position: 'relative',
    marginLeft: '10px',
    fontSize: '15px',
    fontWeight: '600',
    color: 'black'
  },
  tablecell: {
    fontSize: '13px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    verticalAlign: 'top',
    fontWeight: 1000
  },
  tablecell1: {
    fontSize: '13px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    verticalAlign: 'top'
  }
})

const WorkshiftJournal = ({
  classes,
  invoiceFormControl,
  workshift_journal,
  isEditInvoice,
  workshift_journal_not_attached,
  errors,
  attachedWorkShiftJournalIds,
  clearAttachWorkshiftJournalId
}) => {
  const addWorkshiftJournalCheck = useWatch({
    fields: 'addWorkshiftJournal',
    control: invoiceFormControl
  })
  const groupInvoiceCheck = useWatch({
    fields: 'groupInvoice',
    control: invoiceFormControl
  })
  const handleCheckAddWorkshiftJournal = (e) => {
    const isChecked = e.target.checked
    if (!isChecked) {
      clearAttachWorkshiftJournalId()
    }
  }
  return (
    <Translation>
      {(t) => {
        return (
          <div className="row">
            <div className="dashboard-content-header">
              <div className="col-xs-12 col-sm-12 col-lg-12">
                <div className="panel panel-default">
                  <div style={{ padding: '15px' }}>
                    <Field
                      name="addWorkshiftJournal"
                      label={t('invoice.button11')}
                      inputType="switch"
                      control={invoiceFormControl}
                      className={classes.switch}
                      onChange={(e) => handleCheckAddWorkshiftJournal(e)}
                      disabled={groupInvoiceCheck.groupInvoice ? true : false}
                    />
                  </div>
                  {addWorkshiftJournalCheck.addWorkshiftJournal ? (
                    <div style={{ padding: '20px' }}>
                      <div
                        className="central-text"
                        style={{
                          fontWeight: 1000,
                          fontSize: '15px',
                          padding: '8px'
                        }}
                      >
                        {t('ws_journal.h1')}
                      </div>
                      <div className="dashboard-content-header">
                        <div>
                          <div className="panel panel-default">
                            <div className="panel-heading"></div>
                            <div
                              className="panel-body pd-0"
                              style={
                                errors?.attachedJournal &&
                                attachedWorkShiftJournalIds.length <= 0
                                  ? { border: '2px solid red' }
                                  : {}
                              }
                            >
                              <SortableTable
                                data={
                                  isEditInvoice
                                    ? workshift_journal
                                    : workshift_journal_not_attached
                                }
                                createRowComponent={createJournalRow}
                                headerCells={journalCells}
                                enableFilters={true}
                                tablePlace="workshift_journal"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const journalCells = [
  {
    id: 'checkbox',
    label: '',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  },
  {
    id: 'invoice_id',
    label: 'ws_journal.cell1',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  },
  {
    id: 'journal_id',
    label: 'ws_journal.cell6',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  },
  {
    id: 'task_description',
    label: 'ws_journal.cell2',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px',
      width: '400px'
    }
  },
  {
    id: 'date',
    label: 'workshift.cell1',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  },
  // {
  //   id: 'sum',
  //   label: 'ws_journal.cell3',
  //   isSortable: false,
  //   padding: 'normal',
  //   style: {
  //     paddingLeft: '16px'
  //   }
  // },
  {
    id: 'total_sum',
    label: 'ws_journal.cell5',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  }
  // {
  //   id: 'action',
  //   label: '',
  //   isSortable: false,
  //   padding: 'normal',
  //   style: {
  //     paddingLeft: '16px'
  //   }
  // }
]

const createJournalRow = (el, index) => {
  return (
    <WorkshiftJournalRowContainer
      index={index}
      key={el.journal_id}
      invoice_id={el.invoice_id}
      journal_id={el.journal_id}
      task_description={el.task_description}
      totalJournalAmount={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.totalJournalAmount)}
      dateTimeRows={el.dateTimeRows}
    />
  )
}

WorkshiftJournalComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(WorkshiftJournal)
